import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from "../_redux-constants";

export function notificationReducer(state = { notifications: [] }, action) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return Object.assign({}, state, {
        notifications: [...state.notifications, action.payload],
      });

    case REMOVE_NOTIFICATION:
      return Object.assign({}, state, {
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        ),
      });

    default:
      return state;
  }
}
